const intro = (
  <>
    <p>
      Sekcja <strong>"Kursy"</strong> to rozbudowana platforma szkoleniowa dla
      lekarzy, studentów oraz innych specjalistów ochrony zdrowia. Oferuje
      szeroki wybór kursów online, które wspierają rozwój zawodowy, pomagają
      aktualizować wiedzę i podnosić kwalifikacje. Dzięki elastycznej formule
      uczestnicy mogą zdobywać nowe umiejętności w dogodnym dla siebie czasie i
      miejscu, dostosowując naukę do codziennej praktyki klinicznej.
    </p>
    <p>
      Wszystkie kursy są przygotowywane przez ekspertów i zgodne z najnowszymi
      wytycznymi medycznymi, co gwarantuje wysoką jakość merytoryczną. Platforma
      umożliwia dostęp do interaktywnych materiałów dydaktycznych, nagrań wideo,
      testów sprawdzających oraz certyfikatów potwierdzających ukończenie
      szkolenia.
    </p>
  </>
);

const content = (
  <>
    <h3>Kursy dopasowane do realiów medycyny</h3>
    <p>
      Nowoczesna medycyna wymaga ciągłego podnoszenia kwalifikacji.{" "}
      <strong>Kursy na Remedium</strong> to zbiór wartościowych szkoleń
      dostosowanych do praktycznych potrzeb lekarzy, rezydentów i studentów
      medycyny.
    </p>

    <p>Wśród kursów dostępnych na platformie znajdują się m.in.:</p>
    <ul>
      <li>
        <strong>Diagnostyka i leczenie bólów głowy i twarzy</strong> –
        kompleksowe podejście do rozpoznawania i leczenia częstych schorzeń
        neurologicznych.
      </li>
      <li>
        <strong>Badania diagnostyczne w POZ</strong> – szkolenie dla lekarzy
        rodzinnych i internistów, ułatwiające interpretację badań
        laboratoryjnych i obrazowych.
      </li>
      <li>
        <strong>Leczenie ran pooperacyjnych</strong> – najnowsze metody
        postępowania zapobiegające powikłaniom chirurgicznym.
      </li>
      <li>
        <strong>Immunologia i choroby układu oddechowego</strong> – szkolenie
        obejmujące diagnostykę i terapię infekcji oraz schorzeń
        autoimmunologicznych.
      </li>
      <li>
        <strong>Opieka koordynowana w POZ</strong> – kurs dla lekarzy
        podstawowej opieki zdrowotnej, dotyczący strategii leczenia pacjentów z
        chorobami przewlekłymi.
      </li>
    </ul>
    <p>
      Regularnie aktualizowana baza kursów pozwala na śledzenie najnowszych
      wytycznych oraz zmian w standardach postępowania.
    </p>

    <h3>Praktyczne podejście do nauki – elastyczność i interaktywność</h3>
    <p>
      Kursy na Remedium zostały zaprojektowane w sposób ułatwiający
      systematyczne przyswajanie wiedzy i jej zastosowanie w praktyce
      klinicznej. Każdy program zawiera:
    </p>
    <ul>
      <li>
        <strong>
          Wideo wykłady prowadzone przez doświadczonych specjalistów
        </strong>
        ,
      </li>
      <li>
        <strong>Webinary na żywo z możliwością zadawania pytań</strong>,
      </li>
      <li>
        <strong>Testy sprawdzające wiedzę i interaktywne case studies</strong>,
      </li>
      <li>
        <strong>Certyfikaty ukończenia kursu</strong>,
      </li>
      <li>
        <strong>
          Dodatkowe materiały edukacyjne – artykuły, analizy przypadków,
          najnowsze wytyczne kliniczne
        </strong>
        .
      </li>
    </ul>
    <p>
      Dzięki temu użytkownicy mogą nie tylko uczyć się teoretycznie, ale także
      na bieżąco weryfikować swoją wiedzę i stosować ją w praktyce.
    </p>

    <h3>Dostępność i wygoda nauki online</h3>
    <p>
      Platforma Remedium oferuje pełną elastyczność nauki – kursy można
      realizować w dowolnym tempie, bez konieczności dostosowywania się do
      harmonogramu zajęć stacjonarnych. Szkolenia są dostępne z poziomu
      komputera, tabletu oraz smartfona, co pozwala na naukę w każdym miejscu i
      o każdej porze.
    </p>
    <p>
      Dzięki kursom online lekarze i studenci mogą podnosić swoje kwalifikacje
      bez konieczności rezygnacji z pracy czy praktyk klinicznych.
    </p>

    <h3>Dlaczego warto wybrać kursy na Remedium?</h3>
    <ul>
      <li>
        <strong>Aktualna wiedza</strong> – kursy odzwierciedlają najnowsze
        wytyczne i standardy kliniczne.
      </li>
      <li>
        <strong>Rozwój zawodowy</strong> – certyfikaty ukończenia kursów
        podnoszą kwalifikacje i zwiększają konkurencyjność na rynku pracy.
      </li>
      <li>
        <strong>Praktyczne podejście</strong> – szkolenia są skoncentrowane na
        realnych problemach spotykanych w codziennej praktyce lekarskiej.
      </li>
      <li>
        <strong>Elastyczność nauki</strong> – możliwość realizacji kursów w
        dowolnym czasie i miejscu.
      </li>
      <li>
        <strong>Wygodny dostęp</strong> – kursy są dostępne na różnych
        urządzeniach, co pozwala na naukę w dogodnym momencie.
      </li>
    </ul>

    <h3>Podsumowanie</h3>
    <p>
      Sekcja <strong>"Kursy"</strong> na Remedium to nowoczesna platforma
      edukacyjna dla lekarzy, studentów i specjalistów medycznych, oferująca
      szeroki wybór szkoleń online dostosowanych do realiów praktyki klinicznej.
      Dzięki współpracy z ekspertami oraz interaktywnym metodom nauki
      użytkownicy mogą zdobywać aktualną wiedzę, doskonalić umiejętności i
      rozwijać swoją ścieżkę zawodową.
    </p>
  </>
);

export const courseDescription = { intro, content };
